// Helpers for building consistent export document filenames across web and mobile.

const ISO_DATE_PREFIX = /^(\d{4})-(\d{2})-(\d{2})/;
const DD_MM_YYYY = /^\d{2}-\d{2}-\d{4}$/;

// Strips characters unsafe for filenames and caps length to avoid OS path limits.
export function sanitizeFilename(text: string): string {
  return text.replace(/[^a-zA-Z0-9_-]/g, '_').substring(0, 40);
}

// Formats a date string as DD-MM-YYYY for export filenames.
// Accepts ISO (YYYY-MM-DD), already-formatted DD-MM-YYYY, or slash-separated dates.
// Uses UTC parts for ISO input to avoid timezone shifts changing the displayed date.
// Falls back to sanitizeFilename if the input cannot be parsed.
export function formatDateForFilename(dateStr: string): string {
  if (!dateStr) {
    return sanitizeFilename(dateStr);
  }

  const isoMatch = dateStr.match(ISO_DATE_PREFIX);
  if (isoMatch) {
    const [, yyyy, mm, dd] = isoMatch;
    return `${dd}-${mm}-${yyyy}`;
  }

  if (DD_MM_YYYY.test(dateStr)) {
    return dateStr;
  }

  const slashNormalized = dateStr.replace(/\//g, '-');
  if (DD_MM_YYYY.test(slashNormalized)) {
    return slashNormalized;
  }

  try {
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) {
      return sanitizeFilename(dateStr);
    }
    const dd = String(d.getUTCDate()).padStart(2, '0');
    const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
    const yyyy = d.getUTCFullYear();
    return `${dd}-${mm}-${yyyy}`;
  } catch {
    return sanitizeFilename(dateStr);
  }
}
